module.exports = __webpack_public_path__ + "static/media/about-obersurfaces.60ed69a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-obersurfaces.jpg
// module id = 1193
// module chunks = 37